


















import SettingsNavigation from "@/employer/components/settings/SettingsNavigation.vue";
import EmployerBankSettingsForm from "@/employer/components/profile/EmployerBankSettingsForm.vue";
import { useUserStore } from "@/shared/store/user";
import {
  Vue,
  Component,
} from "@/shared/vuepack";

@Component({
  components: {
    SettingsNavigation,
    EmployerBankSettingsForm
  }
})
export default class MassTransitSettings extends Vue {
  userStore = useUserStore();
}
